import { render, staticRenderFns } from "./ProductFeedItem.vue?vue&type=template&id=7601e6b4"
import script from "./ProductFeedItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductFeedItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopProductTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopProductTile.vue').default,TrackProductImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackProductImpression.vue').default})
